<template>
  <div class="pt-2 pb-2">
    <div class="container-fluid">
      <div class="row bg-primary text-secondary p-4 mb-3">
        <div class="col fw-bold text-center fs-3">
          Welcome to the ePoster Area for the 49th Annual Meeting of the EBMT
        </div>
      </div>
      <div class="row">
        <div class="col offset-md-1 text-secondary font-weight-bold mb-1">Browse by</div>
      </div>
      <div class="row">
        <div class="col" v-bind:class="!isMobile() ? 'offset-lg-1':''">
          <button class="btn btn-block btn-secondary text-primary w-100" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasTopGroupSelectionThemes">
            <div class="d-flex">
              <icon :icon="['fad', 'layer-group']" class="fa-6x float-start"/>
              <h4 class="my-auto mx-auto"><span class="font-weight-bold">Topics</span>
                <br>({{ statistics.Themes }} topics)</h4>
            </div>
          </button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-secondary text-primary w-100" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasTopGroupSelectionAuthors">
            <div class="d-flex">
              <icon :icon="['fad', 'users']" class="fa-6x float-start"/>
              <h4 class="my-auto mx-auto"><span class="font-weight-bold">Authors</span> <br> ({{ statistics.Author }}
                authors)</h4>
            </div>
          </button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-secondary text-primary w-100"
                  v-on:click="setViewAndGo('title')">
            <div class="d-flex">
              <icon :icon="['fad', 'sort-alpha-down']" class="fa-6x float-start"/>
              <h4 class="my-auto mx-auto"><span class="font-weight-bold">Title</span><br> ({{ statistics.Poster }}
                titles)
              </h4>
            </div>
          </button>
        </div>
        <div v-bind:class="isMobile() ? 'd-none':'col-lg-1'">&nbsp;</div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import GroupSelectionCards from "./groups/GroupSelectionThemes";

export default {
  components: {GroupSelectionCards},

  computed: {
    ...mapState(['posters', 'mode', 'statistics', 'fullscreen', 'ratings', 'ratingstop5', 'selectedTheme']),
    ...mapState('session', ['sessionlist'])
  },
  methods: {
    ...mapMutations(['setSelectedView']),
    goView() {
      this.$router.push('view');
    },
    setViewAndGo(mode) {
      this.setSelectedView(mode);
      this.goView();
    },
  },
  created() {
    this.$store.dispatch('GET_TOP5_RATINGS');
    this.$store.state.fullscreen = false;
    this.$store.state.presentationSite = null;
  }
}
</script>
